import { connect, } from 'react-redux';

import { AppState, } from '../../sew-core/types/index';
import ConsumerReviewPanel from '../components/ConsumerReviewPanel';
import { onConsumerReviewsMoreReviewsClick, } from '../../sew-core/actions';

const mapStateToProps = (state: AppState,) => ({
  consumerReviewAndRating: state.consumerReviewAndRating,
  vehicle: state.vehicle,
});

const mapDispatchToProps = (dispatch,) => ({
  onConsumerReviewsMoreReviewsClick: () => dispatch(onConsumerReviewsMoreReviewsClick(),),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConsumerReviewPanel,);
